import { Culture } from "@eurodrive/utils"
import dynamic from "next/dynamic"
import { useMemo } from "react"

const defaultComponents = {}

// Cache for dynamic components to prevent re-creating them on every render
const componentCache = new Map<any, any>()

const BlockRenderer = ({
  blockType,
  blockData,
  components,
  children,
  culture,
  locale,
  props,
}: {
  blockType: string
  blockData: any
  components: any
  children?: any
  props?: any
  locale?: string
  culture?: Culture
}) => {
  const effectiveComponents = { ...defaultComponents, ...components }
  if (!effectiveComponents[blockType]) {
    return <div>No Component Found</div> // TODO: remove when production
  }

  // Use cached dynamic component to prevent remounting on navigation
  const ComponentToRender = useMemo(() => {
    const componentLoader = effectiveComponents[blockType]

    if (!componentCache.has(componentLoader)) {
      componentCache.set(componentLoader, dynamic(componentLoader))
    }

    return componentCache.get(componentLoader)
  }, [effectiveComponents, blockType])

  return (
    <ComponentToRender
      data={blockData}
      locale={locale}
      culture={culture}
      {...props}
    >
      {children}
    </ComponentToRender>
  )
}

export default BlockRenderer
